import type { SxStyle, SxStyleFunc } from '@aibees/shared/theme';

export const root: SxStyleFunc<boolean> = (isLast) => ({
  p: 1,
  pt: 0.75,
  pb: 1.5,
  borderBottomColor: (p) => p.palette.grey[400],
  borderBottomStyle: 'dashed',
  borderBottomWidth: !isLast ? '1px' : '0px',
});

export const iconWrapper: SxStyle = {
  p: 0.25,
  background: (p) => p.palette.common.white,
  borderRadius: (p) => p.spacing(0.5),
};

export const icon: SxStyleFunc<boolean | undefined> = (isPeople) => ({
  color: isPeople
    ? (p) => p.palette.success[700]
    : (p) => p.palette.primary[500],
});

export const name: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: (p) => p.typography.fontWeightSemiBold,
};

export const score: SxStyle = {
  fontSize: (p) => p.typography.body2.fontSize,
  fontWeight: 900,
};
